<section class="registro">
	<div class="registro-header fondo-blue"></div>
	<section class="registro-form">
		<div class="registro-form-image">
			<img src="assets/images/logo-big.png" alt="Pawerful PetShop.">
		</div>
		<div class="registro-form-titulo">
			<h3 *ngIf=" step === 1 ">Crear Cuenta</h3>
			<h3 *ngIf=" step === 2 ">Crea tu contraseña</h3>
		</div>
		<div class="registro-form-state">
			<div [ngClass]="{'active': ( step === 1)}" (click)="fnCambiarPaso()">
				<h3> 1. Tus datos </h3>
			</div>
			<div [ngClass]="{'active': ( step === 2)}">
				<h3> 2. Creación de contraseña </h3>
			</div>
		</div>
		<div *ngIf=" step === 1 " class="registro-form-controls">
			<div class="control col10 offset1">
				<input [(ngModel)]="newCuenta.nombre" type="text" placeholder="Nombre(s)" (ngModelChange)="fnValidarNombreApellido($event, 'nombre')">
			</div>
			<div class="control col10 offset1">
				<input [(ngModel)]="newCuenta.paterno" type="text" placeholder="Apellido paterno"  (ngModelChange)="fnValidarNombreApellido($event, 'paterno')">
			</div>
			<div class="control col10 offset1">
				<input [(ngModel)]="newCuenta.materno" type="text" placeholder="Apellido materno " (ngModelChange)="fnValidarNombreApellido($event, 'materno')">
			</div>
			<div class="control col10 offset1">
				<input [(ngModel)]="newCuenta.username" type="email" placeholder="Correo electrónico">
			</div>
			<div class="control col10 offset1">
				<input type="tel" class="telInput"
				placeholder="222 123 4567" 
				ng2TelInput
				[ng2TelInputOptions]="{initialCountry: 'in'}"
				(hasError)="hasError($event)"
				(ng2TelOutput)="getNumber($event)"
				(intlTelInputObject)="telInputObject($event)"
				(countryChange)="onCountryChange($event)"
				maxlength="10" />
			</div>
		</div>
		<div *ngIf=" step === 2 " class="registro-form-controls">
			<div class="col10 offset1">
				<div class="control input-icon">
					<input [(ngModel)]="newCuenta.password" type="{{(showPassword)?'text':'password'}}" placeholder="Contraseña">
					<section (click)="fnAcccionPassword( 1 )">
						<span *ngIf="showPassword"><i class="far fa-eye"></i></span>
						<span *ngIf="!showPassword"><i class="far fa-eye-slash"></i></span>
					</section>
				</div>
			</div>
			<div class="col10 offset1">
				<div class="control input-icon">
					<input [(ngModel)]="newCuenta.confirmar" type="{{(showConfirmar)?'text':'password'}}" placeholder="Confirmar contraseña">
					<section (click)="fnAcccionPassword( 2 )">
						<span *ngIf="showConfirmar"><i class="far fa-eye"></i></span>
						<span *ngIf="!showConfirmar"><i class="far fa-eye-slash"></i></span>
					</section>
				</div>
			</div>
		</div>
		<div class="registro-form-content-controls">
			<div class="col10 offset1">
				<button *ngIf=" step === 1 " (click)="fnValidarDatos()" class="registro-form-content-button fondo-purple">
					Siguiente
				</button>
			</div>
			<div class="col10 offset1">
				<button *ngIf=" step === 2 " (click)="fnRegistrarCuenta()" class="registro-form-content-button fondo-purple">
					Crear cuenta
				</button>
			</div>
		</div>
		<div class="registro-form-controls">
			<hr>
		</div>
		<div class="registro-form-controls center">
			<label class="link">¿Ya tienes una cuenta?</label>
			<button class="btnAcceso" [routerLink]="['/acceso']">
				INICIA SESIÓN
			</button>
			<label class="terminos">
				Al registrarse acepta los
				<a [routerLink]="['/terminos-condiciones']">Términos y Condiciones  </a> así como el <a [routerLink]="['/aviso-privacidad']">Aviso de Privacidad </a> de Pawerful.com
			</label>
		</div>
	</section>
</section>

